export default __webpack_public_path__ + "static/media/feed.7b836d82.svg";